import type { AnyInputBinding } from "./InputBinding/InputBindingUnion.type"
import { InputBindingDevice } from "./InputBindingDevice.enum"

export default function touchClickEventMatchesInputActionBinding(
  event: TouchEvent,
  input: AnyInputBinding,
): boolean {
  if (input.device === InputBindingDevice.Touch) {
    if (event.touches.length === 1 && input.click) {
      return true
    }
  }
  return false
}
